module.exports = __webpack_public_path__ + "img/user-tolya.2ec82553.svg";